import { Tag } from 'antd';

const COLOR_MAP = {
  success: 'green',
  成功: 'green',
  有效: 'green',
  已入账: 'green',
  已缴款: 'green',
  已申报: 'blue',
  processing: 'orange',
  处理中: 'orange',
  审核中: 'orange',
  待处理: 'orange',
  未入账: 'default',
  未申报: 'default',
  签署中: 'orange',
  fail: 'red',
  失败: 'red',
  已失效: 'red',
};

export default function FinanceStatusTag({ text, color }) {
  return <Tag color={color || COLOR_MAP[text] || 'default'}>{text || '-'}</Tag>;
}
